module.exports = __webpack_public_path__ + "static/media/bgr-two-md.5740a52f.webp";